import React from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';

import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import moment from 'moment';
import {
  StyledTableCell,
  StyledTableRow,
} from '../../../../../../components/V2/Table/type1/TableStyles';
import { ISitemap } from '../../../../../../store/V2/SitemapSlice';

interface SitemapTableRowProps {
  sitemap: ISitemap;
}

const SitemapTableRow: React.FC<SitemapTableRowProps> = ({ sitemap }) => {
  const createdAt = moment(sitemap.createdAt);

  const handleOpen = (url: string) => {
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <StyledTableRow hover key={sitemap._id}>
      <StyledTableCell>
        <Box display="flex">
          <Typography
            fontSize="14px"
            fontWeight={500}
            color="#1E293B"
            className="ellipsis-text two-lines"
          >
            {sitemap.name}
          </Typography>
          <IconButton
            onClick={() => handleOpen(sitemap.path)}
            sx={{ p: 0, ml: 1 }}
          >
            <OpenInNewIcon sx={{ fontSize: '20px' }} />
          </IconButton>
        </Box>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {sitemap.status}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Typography
          fontSize="14px"
          fontWeight={500}
          color="#1E293B"
          className="ellipsis-text two-lines"
        >
          {sitemap.urlCount}
        </Typography>
      </StyledTableCell>
      <StyledTableCell>
        <Stack>
          <Typography fontSize="14px" fontWeight={500} color="#1E293B">
            {createdAt.format('ddd MMM DD YYYY')}
          </Typography>
          <Typography fontSize="12px" color="#94A3B8">
            {createdAt.format('hh:mm A')}
          </Typography>
        </Stack>
      </StyledTableCell>
    </StyledTableRow>
  );
};

export default SitemapTableRow;
